// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-report .container-fluid {
  max-width: 1400px;
  margin: 0 auto;
}
.sample-report .page-header .page-title {
  font-size: 2rem;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
}
.sample-report .page-header .page-title i {
  color: #764ba2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}
.sample-report .page-header .page-subtitle {
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0;
  color: #6c757d;
}
.sample-report .form-label-required {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
}
.sample-report .form-label-required::after {
  content: " *";
  color: #ef4444;
}
.sample-report .card {
  border: none;
  border-radius: 16px;
  transition: all 0.3s ease;
  overflow: hidden;
}
.sample-report .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
}
.sample-report .card.selection-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .sample-report .card.selection-card {
  background: rgba(33, 37, 41, 0.95);
  border-color: rgba(102, 126, 234, 0.2);
}
.sample-report .card.details-card {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(102, 126, 234, 0.1);
}
[data-coreui-theme=dark] .sample-report .card.details-card {
  background: rgba(33, 37, 41, 0.98);
}
.sample-report .card .card-header {
  border-radius: 16px 16px 0 0 !important;
  padding: 1.5rem 2rem;
  border-bottom: none;
  position: relative;
}
.sample-report .card .card-header.gradient-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
}
.sample-report .card .card-header.gradient-header::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.3) 50%, transparent 100%);
}
.sample-report .card .card-header.gradient-header h5 {
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.sample-report .card .card-header.gradient-header i {
  opacity: 0.9;
}
.sample-report .card .card-body {
  padding: 2rem;
  background: #ffffff;
}
[data-coreui-theme=dark] .sample-report .card .card-body {
  background: #212529;
}
.sample-report .action-buttons-group {
  display: flex;
  gap: 12px;
  width: 100%;
}
.sample-report .action-buttons-group .btn-report-generate {
  flex: 1 1;
  padding: 12px 24px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}
.sample-report .action-buttons-group .btn-report-generate:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
  background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);
}
.sample-report .action-buttons-group .btn-report-generate:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.sample-report .action-buttons-group .btn-report-generate i {
  margin-right: 8px;
}
.sample-report .action-buttons-group .btn-clear {
  padding: 12px 20px;
  font-weight: 600;
  border-radius: 12px;
  font-size: 0.95rem;
  background: transparent;
  border: 2px solid #e5e7eb;
  color: #6b7280;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}
.sample-report .action-buttons-group .btn-clear:hover:not(:disabled) {
  border-color: #ef4444;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}
.sample-report .action-buttons-group .btn-clear:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.sample-report .action-buttons-group .btn-clear .clear-icon {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1;
}
.sample-report .details-header {
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%) !important;
  border-bottom: 1px solid rgba(102, 126, 234, 0.15);
  padding: 1.5rem 2rem;
}
[data-coreui-theme=dark] .sample-report .details-header {
  background: linear-gradient(135deg, #1a1d21 0%, #212529 100%) !important;
  border-bottom-color: rgba(102, 126, 234, 0.3);
}
.sample-report .details-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.sample-report .details-info .details-title {
  color: #374151;
  font-weight: 600;
}
.sample-report .details-info .details-title i {
  color: #667eea;
}
[data-coreui-theme=dark] .sample-report .details-info .details-title {
  color: #e5e7eb;
}
.sample-report .details-info .details-badges {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.sample-report .details-info .detail-badge {
  padding: 6px 12px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
}
.sample-report .details-info .detail-badge.code-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.sample-report .details-info .detail-badge.type-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}
.sample-report .details-info .detail-badge.date-badge {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}
.sample-report .details-info .detail-badge i {
  opacity: 0.9;
}
.sample-report .action-buttons-export {
  display: flex;
  gap: 10px;
}
.sample-report .action-buttons-export .btn-action-print,
.sample-report .action-buttons-export .btn-action-excel {
  padding: 10px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.85rem;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.3s ease;
}
.sample-report .action-buttons-export .btn-action-print:hover:not(:disabled),
.sample-report .action-buttons-export .btn-action-excel:hover:not(:disabled) {
  transform: translateY(-2px);
}
.sample-report .action-buttons-export .btn-action-print:disabled,
.sample-report .action-buttons-export .btn-action-excel:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.sample-report .action-buttons-export .btn-action-print {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}
.sample-report .action-buttons-export .btn-action-print:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}
.sample-report .action-buttons-export .btn-action-excel {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}
.sample-report .action-buttons-export .btn-action-excel:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);
}
.sample-report .report-preview-card {
  border: none !important;
  border-radius: 16px;
  overflow: visible;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}
.sample-report .report-preview-card .card-body {
  background: #f3f4f6;
  padding: 0 !important;
  overflow: visible;
}
[data-coreui-theme=dark] .sample-report .report-preview-card .card-body {
  background: #1a1d21;
}
.sample-report .report-a4-preview {
  display: block;
  width: 100%;
  max-width: 100%;
  min-height: auto;
  margin: 0 auto;
  padding: 0.75rem 1rem;
  background: #ffffff;
  box-shadow: none;
  border-radius: 0;
  overflow-x: auto;
  overflow-y: visible;
}
.sample-report .report-a4-preview .report-wrap {
  width: 210mm;
  max-width: 210mm;
  margin: 0 auto;
  border: 1px solid #000;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
}
.sample-report .report-a4-preview .sample-main-page {
  min-height: 297mm;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
}
.sample-report .report-a4-preview .sample-main-photo {
  margin-top: 10mm;
  text-align: left;
  padding-left: 4px;
}
.sample-report .report-a4-preview .sample-main-photo img {
  height: 220px;
  width: 520px;
  object-fit: fill;
}
.sample-report .report-a4-preview .sample-report-page {
  width: 100%;
  max-width: none;
  min-height: 190mm;
  padding: 0;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  margin: 2rem auto 0;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.sample-report .report-a4-preview .sample-report-page .header-table,
.sample-report .report-a4-preview .sample-report-page .sample-report-brand-bar {
  display: none !important;
}
.sample-report .report-a4-preview .sample-report-rotated-content {
  width: 100%;
  max-width: 100%;
  min-height: auto;
  margin: 0;
  overflow: visible;
}
.sample-report .report-a4-preview .sample-report-rotated-content .header-table {
  font-size: 14px;
  margin-bottom: 8px;
}
.sample-report .report-a4-preview .sample-report-rotated-content .header-table td {
  padding: 6px 8px;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.15;
}
.sample-report .report-a4-preview .sample-report-rotated-content .header-table .label-cell {
  white-space: normal;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-section {
  margin: 8px 0;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-title {
  font-size: 15px;
  padding: 6px 10px;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table {
  font-size: 12px;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table th,
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table td {
  padding: 2px 3px;
  white-space: normal;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.6;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table .yarn-name {
  width: 150px;
  max-width: 150px;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table .weight-col {
  width: 55px;
  max-width: 55px;
  font-size: 12px;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table .position-col {
  width: 22px;
  min-width: 22px;
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
}
.sample-report .report-a4-preview .sample-report-rotated-content .color-report-table .factor-range-merged {
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
}
.sample-report .report-a4-preview .info-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 15px;
  margin: 0;
}
.sample-report .report-a4-preview .info-table td {
  border: 1px solid #000;
  padding: 7px 11px;
  background: #ffffff;
  vertical-align: middle;
}
.sample-report .report-a4-preview .info-table tr:first-child td {
  border-top: none;
}
.sample-report .report-a4-preview .info-table .label-cell {
  background: #f8f9fa;
  font-weight: 600;
  width: 20%;
  color: #000;
}
.sample-report .report-a4-preview .info-table .value-cell {
  background: #ffffff;
  color: #000;
  width: 50%;
}
.sample-report .report-a4-preview .info-table .note-cell {
  background: #ffffff;
  color: #000;
  width: 30%;
  word-break: break-all;
  overflow-wrap: break-word;
}
.sample-report .report-a4-preview .info-table .price-cell {
  font-size: 15px;
  font-weight: 400;
  color: #000;
}
[data-coreui-theme=dark] .sample-report .report-a4-preview {
  background: #2d3748;
}
[data-coreui-theme=dark] .sample-report .report-a4-preview .report-wrap {
  border-color: #4a5568;
}
[data-coreui-theme=dark] .sample-report .report-a4-preview .header-grid,
[data-coreui-theme=dark] .sample-report .report-a4-preview .logo-cell,
[data-coreui-theme=dark] .sample-report .report-a4-preview .title-cell,
[data-coreui-theme=dark] .sample-report .report-a4-preview .meta-cell,
[data-coreui-theme=dark] .sample-report .report-a4-preview .info-table td {
  background: #2d3748;
  border-color: #4a5568;
  color: #e2e8f0;
}
[data-coreui-theme=dark] .sample-report .report-a4-preview .label-cell {
  background: #3d4a5a !important;
}
@media (max-width: 992px) {
  .sample-report .action-buttons-group {
    flex-direction: column;
  }
  .sample-report .details-header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .sample-report .action-buttons-export {
    width: 100%;
    justify-content: flex-start;
  }
  .sample-report .report-a4-preview {
    padding: 10mm 5mm;
    min-height: auto;
  }
}
@media (max-width: 576px) {
  .sample-report .page-header .page-title {
    font-size: 1.5rem;
  }
  .sample-report .card .card-body {
    padding: 1.25rem;
  }
  .sample-report .details-badges {
    flex-direction: column;
    gap: 6px;
  }
}
.sample-report .sample-photo-container {
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #ddd;
}
.sample-report .sample-photo-container img {
  max-width: 100%;
  max-height: 300px;
  object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/SampleReport/SampleReport.scss"],"names":[],"mappings":"AAIE;EACE,iBAAA;EACA,cAAA;AAHJ;AAOI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AALN;AAOM;EACE,cAAA;EACA,iDAAA;AALR;AASI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAPN;AAWE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AATJ;AAWI;EACE,aAAA;EACA,cAAA;AATN;AAcE;EACE,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,2BAAA;EACA,sDAAA;AAZN;AAeI;EACE,2BAAA;EACA,qCAAA;EACA,0CAAA;AAbN;AAeM;EACE,kCAAA;EACA,sCAAA;AAbR;AAiBI;EACE,qCAAA;EACA,2BAAA;EACA,0CAAA;AAfN;AAiBM;EACE,kCAAA;AAfR;AAmBI;EACE,uCAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;AAjBN;AAmBM;EACE,wEAAA;EACA,uBAAA;AAjBR;AAmBQ;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,kGAAA;AAjBV;AAuBQ;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;AArBV;AAwBQ;EACE,YAAA;AAtBV;AA2BI;EACE,aAAA;EACA,mBAAA;AAzBN;AA2BM;EACE,mBAAA;AAzBR;AA+BE;EACE,aAAA;EACA,SAAA;EACA,WAAA;AA7BJ;AA+BI;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;AA7BN;AA+BM;EACE,2BAAA;EACA,+CAAA;EACA,6DAAA;AA7BR;AAgCM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA9BR;AAiCM;EACE,iBAAA;AA/BR;AAmCI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAjCN;AAmCM;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;AAjCR;AAoCM;EACE,YAAA;EACA,mBAAA;AAlCR;AAqCM;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AAnCR;AAyCE;EACE,wEAAA;EACA,kDAAA;EACA,oBAAA;AAvCJ;AAyCI;EACE,wEAAA;EACA,6CAAA;AAvCN;AA2CE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAzCJ;AA6CI;EACE,cAAA;EACA,gBAAA;AA3CN;AA6CM;EACE,cAAA;AA3CR;AA8CM;EACE,cAAA;AA5CR;AAgDI;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA9CN;AAiDI;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AA/CN;AAiDM;EACE,6DAAA;EACA,YAAA;AA/CR;AAkDM;EACE,6DAAA;EACA,YAAA;AAhDR;AAmDM;EACE,6DAAA;EACA,YAAA;AAjDR;AAoDM;EACE,YAAA;AAlDR;AAwDE;EACE,aAAA;EACA,SAAA;AAtDJ;AAwDI;;EAEE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAtDN;AAwDM;;EACE,2BAAA;AArDR;AAwDM;;EACE,YAAA;EACA,mBAAA;AArDR;AAyDI;EACE,6DAAA;EACA,YAAA;EACA,8CAAA;AAvDN;AAyDM;EACE,8CAAA;AAvDR;AA2DI;EACE,6DAAA;EACA,YAAA;EACA,8CAAA;AAzDN;AA2DM;EACE,8CAAA;AAzDR;AA+DE;EACE,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2CAAA;AA7DJ;AA+DI;EACE,mBAAA;EACA,qBAAA;EACA,iBAAA;AA7DN;AA+DM;EACE,mBAAA;AA7DR;AAmEE;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjEJ;AAoEI;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlEN;AAqEI;EACE,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,sBAAA;AAnEN;AAsEI;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AApEN;AAsEM;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AApER;AAwEI;EACE,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,0CAAA;AAtEN;AAyEI;;EAEE,wBAAA;AAvEN;AA0EI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAxEN;AA2EI;EACE,eAAA;EACA,kBAAA;AAzEN;AA2EM;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AAzER;AA4EM;EACE,mBAAA;AA1ER;AA8EI;EACE,aAAA;AA5EN;AA+EI;EACE,eAAA;EACA,iBAAA;AA7EN;AAgFI;EACE,eAAA;AA9EN;AAgFM;;EAEE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AA9ER;AAiFM;EACE,YAAA;EACA,gBAAA;AA/ER;AAkFM;EACE,WAAA;EACA,eAAA;EACA,eAAA;AAhFR;AAmFM;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AAjFR;AAoFM;EACE,mBAAA;EACA,kBAAA;EACA,qBAAA;AAlFR;AAuFI;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AArFN;AAuFM;EACE,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AArFR;AAwFM;EACE,gBAAA;AAtFR;AAyFM;EACE,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;AAvFR;AA0FM;EACE,mBAAA;EACA,WAAA;EACA,UAAA;AAxFR;AA2FM;EACE,mBAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,yBAAA;AAzFR;AA4FM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA1FR;AA8FI;EACE,mBAAA;AA5FN;AA8FM;EACE,qBAAA;AA5FR;AA+FM;;;;;EAKE,mBAAA;EACA,qBAAA;EACA,cAAA;AA7FR;AAgGM;EACE,8BAAA;AA9FR;AAoGE;EACE;IACE,sBAAA;EAlGJ;EAqGE;IACE,sBAAA;IACA,uBAAA;EAnGJ;EAsGE;IACE,WAAA;IACA,2BAAA;EApGJ;EAuGE;IACE,iBAAA;IACA,gBAAA;EArGJ;AACF;AAwGE;EACE;IACE,iBAAA;EAtGJ;EAyGE;IACE,gBAAA;EAvGJ;EA0GE;IACE,sBAAA;IACA,QAAA;EAxGJ;AACF;AA4GE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AA1GJ;AA4GI;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AA1GN","sourcesContent":["// Sample Report Styles - Modern Design Inspired by CaglikReport\n.sample-report {\n\n  // Container padding fix\n  .container-fluid {\n    max-width: 1400px;\n    margin: 0 auto;\n  }\n\n  .page-header {\n    .page-title {\n      font-size: 2rem;\n      font-weight: 600;\n      color: #667eea;\n      margin-bottom: 0.5rem;\n      display: flex;\n      align-items: center;\n\n      i {\n        color: #764ba2;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n      }\n    }\n\n    .page-subtitle {\n      font-size: 1rem;\n      line-height: 1.5;\n      margin-bottom: 0;\n      color: #6c757d;\n    }\n  }\n\n  .form-label-required {\n    font-weight: 500;\n    color: #374151;\n    margin-bottom: 0.5rem;\n\n    &::after {\n      content: ' *';\n      color: #ef4444;\n    }\n  }\n\n  // Enhanced card styling with AppHeader inspiration\n  .card {\n    border: none;\n    border-radius: 16px;\n    transition: all 0.3s ease;\n    overflow: hidden;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;\n    }\n\n    &.selection-card {\n      backdrop-filter: blur(20px);\n      background: rgba(255, 255, 255, 0.95);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.95);\n        border-color: rgba(102, 126, 234, 0.2);\n      }\n    }\n\n    &.details-card {\n      background: rgba(255, 255, 255, 0.98);\n      backdrop-filter: blur(20px);\n      border: 1px solid rgba(102, 126, 234, 0.1);\n\n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(33, 37, 41, 0.98);\n      }\n    }\n\n    .card-header {\n      border-radius: 16px 16px 0 0 !important;\n      padding: 1.5rem 2rem;\n      border-bottom: none;\n      position: relative;\n\n      &.gradient-header {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n        color: white !important;\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: -1px;\n          left: 0;\n          right: 0;\n          height: 1px;\n          background: linear-gradient(90deg,\n              transparent 0%,\n              rgba(255, 255, 255, 0.3) 50%,\n              transparent 100%);\n        }\n\n        h5 {\n          margin: 0;\n          font-weight: 600;\n          letter-spacing: 0.5px;\n        }\n\n        i {\n          opacity: 0.9;\n        }\n      }\n    }\n\n    .card-body {\n      padding: 2rem;\n      background: #ffffff;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: #212529;\n      }\n    }\n  }\n\n  // Enhanced action buttons group\n  .action-buttons-group {\n    display: flex;\n    gap: 12px;\n    width: 100%;\n\n    .btn-report-generate {\n      flex: 1;\n      padding: 12px 24px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      color: white;\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n      transition: all 0.3s ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);\n        background: linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n\n      i {\n        margin-right: 8px;\n      }\n    }\n\n    .btn-clear {\n      padding: 12px 20px;\n      font-weight: 600;\n      border-radius: 12px;\n      font-size: 0.95rem;\n      background: transparent;\n      border: 2px solid #e5e7eb;\n      color: #6b7280;\n      transition: all 0.3s ease;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n\n      &:hover:not(:disabled) {\n        border-color: #ef4444;\n        color: #ef4444;\n        background: rgba(239, 68, 68, 0.05);\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n      }\n\n      .clear-icon {\n        font-size: 1.2rem;\n        font-weight: 700;\n        line-height: 1;\n      }\n    }\n  }\n\n  // Details card header styling\n  .details-header {\n    background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%) !important;\n    border-bottom: 1px solid rgba(102, 126, 234, 0.15);\n    padding: 1.5rem 2rem;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: linear-gradient(135deg, #1a1d21 0%, #212529 100%) !important;\n      border-bottom-color: rgba(102, 126, 234, 0.3);\n    }\n  }\n\n  .details-header-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  .details-info {\n    .details-title {\n      color: #374151;\n      font-weight: 600;\n\n      i {\n        color: #667eea;\n      }\n\n      [data-coreui-theme=\"dark\"] & {\n        color: #e5e7eb;\n      }\n    }\n\n    .details-badges {\n      display: flex;\n      gap: 8px;\n      flex-wrap: wrap;\n    }\n\n    .detail-badge {\n      padding: 6px 12px;\n      font-size: 0.8rem;\n      font-weight: 500;\n      border-radius: 8px;\n      display: inline-flex;\n      align-items: center;\n\n      &.code-badge {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n      }\n\n      &.type-badge {\n        background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n        color: white;\n      }\n\n      &.date-badge {\n        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n        color: white;\n      }\n\n      i {\n        opacity: 0.9;\n      }\n    }\n  }\n\n  // Export action buttons\n  .action-buttons-export {\n    display: flex;\n    gap: 10px;\n\n    .btn-action-print,\n    .btn-action-excel {\n      padding: 10px 18px;\n      border-radius: 10px;\n      font-weight: 600;\n      font-size: 0.85rem;\n      border: none;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      transition: all 0.3s ease;\n\n      &:hover:not(:disabled) {\n        transform: translateY(-2px);\n      }\n\n      &:disabled {\n        opacity: 0.6;\n        cursor: not-allowed;\n      }\n    }\n\n    .btn-action-print {\n      background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n      color: white;\n      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);\n\n      &:hover:not(:disabled) {\n        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n      }\n    }\n\n    .btn-action-excel {\n      background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n      color: white;\n      box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n\n      &:hover:not(:disabled) {\n        box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4);\n      }\n    }\n  }\n\n  // Report preview card - A4 style preview\n  .report-preview-card {\n    border: none !important;\n    border-radius: 16px;\n    overflow: visible;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n\n    .card-body {\n      background: #f3f4f6;\n      padding: 0 !important;\n      overflow: visible;\n\n      [data-coreui-theme=\"dark\"] & {\n        background: #1a1d21;\n      }\n    }\n  }\n\n  // A4 preview container\n  .report-a4-preview {\n    display: block;\n    width: 100%;\n    max-width: 100%;\n    min-height: auto;\n    margin: 0 auto;\n    padding: 0.75rem 1rem;\n    background: #ffffff;\n    box-shadow: none;\n    border-radius: 0;\n    overflow-x: auto;\n    overflow-y: visible;\n\n    // Report wrapper border\n    .report-wrap {\n      width: 210mm;\n      max-width: 210mm;\n      margin: 0 auto;\n      border: 1px solid #000;\n      border-radius: 4px;\n      overflow: hidden;\n      background: #ffffff;\n    }\n\n    .sample-main-page {\n      min-height: 297mm;\n      background: #ffffff;\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n      box-sizing: border-box;\n    }\n\n    .sample-main-photo {\n      margin-top: 10mm;\n      text-align: left;\n      padding-left: 4px;\n\n      img {\n        height: 220px;\n        width: 520px;\n        object-fit: fill;\n      }\n    }\n\n    .sample-report-page {\n      width: 100%;\n      max-width: none;\n      min-height: 190mm;\n      padding: 0;\n      box-sizing: border-box;\n      overflow: visible;\n      position: relative;\n      margin: 2rem auto 0;\n      background: #ffffff;\n      border: 1px solid rgba(0, 0, 0, 0.08);\n      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n    }\n\n    .sample-report-page .header-table,\n    .sample-report-page .sample-report-brand-bar {\n      display: none !important;\n    }\n\n    .sample-report-rotated-content {\n      width: 100%;\n      max-width: 100%;\n      min-height: auto;\n      margin: 0;\n      overflow: visible;\n    }\n\n    .sample-report-rotated-content .header-table {\n      font-size: 14px;\n      margin-bottom: 8px;\n\n      td {\n        padding: 6px 8px;\n        overflow: hidden;\n        overflow-wrap: anywhere;\n        word-break: break-word;\n        line-height: 1.15;\n      }\n\n      .label-cell {\n        white-space: normal;\n      }\n    }\n\n    .sample-report-rotated-content .color-report-section {\n      margin: 8px 0;\n    }\n\n    .sample-report-rotated-content .color-report-title {\n      font-size: 15px;\n      padding: 6px 10px;\n    }\n\n    .sample-report-rotated-content .color-report-table {\n      font-size: 12px;\n\n      th,\n      td {\n        padding: 2px 3px;\n        white-space: normal;\n        overflow: hidden;\n        overflow-wrap: anywhere;\n        word-break: break-word;\n        line-height: 1.6;\n      }\n\n      .yarn-name {\n        width: 150px;\n        max-width: 150px;\n      }\n\n      .weight-col {\n        width: 55px;\n        max-width: 55px;\n        font-size: 12px;\n      }\n\n      .position-col {\n        width: 22px;\n        min-width: 22px;\n        white-space: nowrap;\n        word-break: normal;\n        overflow-wrap: normal;\n      }\n\n      .factor-range-merged {\n        white-space: nowrap;\n        word-break: normal;\n        overflow-wrap: normal;\n      }\n    }\n\n    // Info table borders - match print output\n    .info-table {\n      width: 100%;\n      border-collapse: collapse;\n      table-layout: fixed;\n      font-size: 15px;\n      margin: 0;\n\n      td {\n        border: 1px solid #000;\n        padding: 7px 11px;\n        background: #ffffff;\n        vertical-align: middle;\n      }\n\n      tr:first-child td {\n        border-top: none;\n      }\n\n      .label-cell {\n        background: #f8f9fa;\n        font-weight: 600;\n        width: 20%;\n        color: #000;\n      }\n\n      .value-cell {\n        background: #ffffff;\n        color: #000;\n        width: 50%;\n      }\n\n      .note-cell {\n        background: #ffffff;\n        color: #000;\n        width: 30%;\n        word-break: break-all;\n        overflow-wrap: break-word;\n      }\n\n      .price-cell {\n        font-size: 15px;\n        font-weight: 400;\n        color: #000;\n      }\n    }\n\n    [data-coreui-theme=\"dark\"] & {\n      background: #2d3748;\n\n      .report-wrap {\n        border-color: #4a5568;\n      }\n\n      .header-grid,\n      .logo-cell,\n      .title-cell,\n      .meta-cell,\n      .info-table td {\n        background: #2d3748;\n        border-color: #4a5568;\n        color: #e2e8f0;\n      }\n\n      .label-cell {\n        background: #3d4a5a !important;\n      }\n    }\n  }\n\n  // Responsive adjustments\n  @media (max-width: 992px) {\n    .action-buttons-group {\n      flex-direction: column;\n    }\n\n    .details-header-content {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .action-buttons-export {\n      width: 100%;\n      justify-content: flex-start;\n    }\n\n    .report-a4-preview {\n      padding: 10mm 5mm;\n      min-height: auto;\n    }\n  }\n\n  @media (max-width: 576px) {\n    .page-header .page-title {\n      font-size: 1.5rem;\n    }\n\n    .card .card-body {\n      padding: 1.25rem;\n    }\n\n    .details-badges {\n      flex-direction: column;\n      gap: 6px;\n    }\n  }\n\n  // Sample photo in report\n  .sample-photo-container {\n    text-align: center;\n    margin-top: 20px;\n    padding: 15px;\n    border: 1px solid #ddd;\n\n    img {\n      max-width: 100%;\n      max-height: 300px;\n      object-fit: contain;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
